import { Box, Typography } from '@mui/material';
import { CUSTOM_BLOCK_CUBOID_STYLES } from '../constants';
import { useAtomValue } from 'jotai';
import * as state from '../state';
import { editPointOfInterest as editPointOfInterestAtom } from '../../pointOfInterest/state';

type LegendProps = {
  color: number;
  label: string;
};
export const Legend = ({ color, label }: LegendProps) => {
  const stringifiedColor = `#${color.toString(16).padStart(6, '0')}`;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ width: 8, height: 8, backgroundColor: stringifiedColor }} />
      <Typography color="white" variant="body1">
        {label}
      </Typography>
    </Box>
  );
};

export const CustomBlockCuboidColorLegends = () => {
  const customBlockCuboids = useAtomValue(state.customBlockCuboids);
  const editPointOfInterest = useAtomValue(editPointOfInterestAtom);
  const selectedSavedBlockId = useAtomValue(state.selectedSavedBlockId);
  const selectedCustomBlock = useAtomValue(state.selectedCustomBlock);

  // If there are no blocks 'checked' in the list
  if (!customBlockCuboids?.size) return <></>;
  // If the user's adding a POI
  if (editPointOfInterest.state !== 'Inactive') return <></>;
  // If a saved block is selected
  if (selectedSavedBlockId) return <></>;
  // If a custom block is selected
  if (selectedCustomBlock) return <></>;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: '18vw',
        bottom: '1vh',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}
    >
      <Legend color={CUSTOM_BLOCK_CUBOID_STYLES.yellow.style.fillColor} label="Open" />
      <Legend color={CUSTOM_BLOCK_CUBOID_STYLES.blue.style.fillColor} label="In Progress" />
      <Legend color={CUSTOM_BLOCK_CUBOID_STYLES.green.style.fillColor} label="Closed" />
      <Legend color={CUSTOM_BLOCK_CUBOID_STYLES.white.style.fillColor} label="Pre Computed" />
    </Box>
  );
};
